// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type CompleteGroupResponse = SuccessResponse | FailedResponse

export class CompleteGroupRequest extends Request {
    private constructor(groupId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}/complete`, init) }
    static async init(groupId: string, init?: RequestInit) {
        return new CompleteGroupRequest(groupId, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<CompleteGroupResponse>(await response.json())
        console.info("Complete Group Results:", data)
    
        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}